import React from 'react';
import {Button, Modal} from "react-bootstrap";
import {deleteNews} from "../../../api/News";

function NewsDelete(props) {
    const [modalShow, setModalShow] = React.useState(false);

    return (
        <>
            <Button style={{marginLeft: 20}} variant="danger" onClick={() => setModalShow(true)}>Supprimer</Button>

            <WarningModal
                show={modalShow}
                id={props.id}
                title={props.title}
                onHide={() => setModalShow(false)}
            />
        </>
    );
}

function WarningModal(props) {
    async function handleDelete() {
        const deleted = await deleteNews(props.id);

        if (deleted.status === 200) {
            window.location.href = "/news"
        }
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Confirmation de suppression
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Êtes-vous sur de vouloir supprimer la news <b>"{props.title}"</b> ?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>Annuler</Button>
                <Button variant="danger" onClick={handleDelete}>Confirmer</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default NewsDelete;
